"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

/**
 * Root-level error fallback. The root layout may be broken when this renders,
 * so it must stay dependency-free: no next-intl, no design-system components,
 * no global CSS — static Czech copy and inline styles only.
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
          color: "#171717",
          fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          textAlign: "center",
        }}
      >
        <div style={{ padding: "2rem", maxWidth: "28rem" }}>
          <p
            style={{
              fontSize: "1.75rem",
              fontWeight: 800,
              margin: "0 0 0.5rem",
              color: "#e5484d",
            }}
          >
            Restomat
          </p>
          <h1 style={{ fontSize: "1.25rem", fontWeight: 600, margin: "0 0 0.75rem" }}>
            Něco se pokazilo
          </h1>
          <p style={{ fontSize: "0.875rem", color: "#666", margin: "0 0 1.5rem" }}>
            Omlouváme se, došlo k neočekávané chybě. Zkuste stránku načíst
            znovu. Pokud problém přetrvává, napište nám na{" "}
            <a href="mailto:ahoj@restomat.cz" style={{ color: "#e5484d" }}>
              ahoj@restomat.cz
            </a>
            .
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: "#171717",
              color: "#fff",
              border: "none",
              borderRadius: "0.5rem",
              padding: "0.625rem 1.5rem",
              fontSize: "0.875rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Načíst znovu
          </button>
          {error.digest && (
            <p style={{ fontSize: "0.75rem", color: "#999", marginTop: "1.5rem" }}>
              Kód chyby: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
